<template>
  <div id="app">
    <Logo/>
    <Loading v-if="$store.state.isLoading" :message="'Loading...'"></Loading>
    <Alert></Alert>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import Alert from '@/components/Alert'
import Logo from '@/components/Logo.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Logo, Footer, Loading, Alert
  },
  created () {
    this.isSafari()
    this.isThisIos()
    this.isThisMobileDevice()
    this.isInStandaloneMode()
  },
  methods: {
    isThisIos () {
      // iPhone and Safari specific fixes
      let userAgent = window.navigator.userAgent
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        this.$store.state.iOS = true
        // this.$store.commit('updateIOS', this.iOS)
      } else {
        this.$store.state.iOS = false
        // this.$store.commit('updateIOS', this.iOS)
      }
    },
    isThisMobileDevice () {
      if ('ontouchstart' in window || navigator.msMaxTouchPoints > 0) {
        this.$store.state.mobileDevice = true
      } else {
        this.$store.state.mobileDevice = false
      }
    },
    isSafari () {
      let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)
      if (isSafari) {
        this.$store.state.isSafari = true
      } else {
        this.$store.state.isSafari = false
      }
    },
    isInStandaloneMode () {
      if (('standalone' in window.navigator) && (window.navigator.standalone)) {
        this.$store.state.standalone = true
      } else {
        this.$store.state.standalone = false
      }
    }
  }
}
</script>
